'use client';

import { createContext } from 'react';

import { NestedTranslations } from '../models/nested-translations.model';

export interface TranslationsContextValue {
   locale: string;
   translations: NestedTranslations | null;
   fallback: NestedTranslations | null;
}

export const TranslationsContext = createContext<TranslationsContextValue>({
   locale: 'en-GB',
   translations: null,
   fallback: null
});
